import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, errMsg, PAYMENT_METHODS } from "../lib/api";

export const SimulatedPay = ({ sim, total, phone, onDone, onClose }) => {
  const m = PAYMENT_METHODS.find((x) => x.id === sim.method);
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const confirm = async () => {
    setBusy(true);
    try { await api.post(`/orders/${sim.order_id}/simulate-confirm`); toast.success("Payment received. Asante!"); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="simulated-pay-dialog">
        <DialogHeader><DialogTitle className="font-display">{m.name} payment</DialogTitle></DialogHeader>
        <div className="rounded-2xl p-5 text-white" style={{ background: m.color }}>
          <p className="text-xs opacity-80">Pay Afri-go · {sim.order_id}</p>
          <p className="font-display text-3xl font-extrabold mt-1">{total}</p>
          <p className="text-xs opacity-80 mt-2">{phone}</p>
        </div>
        <p className="text-xs text-stone-500">Demo mode: this provider's live API keys are not connected yet. Enter any 4-digit PIN to simulate approval.</p>
        <input data-testid="simulated-pin-input" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))} placeholder="PIN" type="password" className="h-12 rounded-xl border px-4 text-center tracking-[0.5em] text-lg" />
        <button data-testid="simulated-confirm-btn" disabled={pin.length !== 4 || busy} onClick={confirm} className="h-12 rounded-full bg-[#1A1714] text-white font-semibold disabled:opacity-40">{busy ? "Confirming..." : "Approve payment"}</button>
      </DialogContent>
    </Dialog>
  );
};
